// Tork.network AI Governance Layer for Roar 4x4
// Provides PII redaction and compliance receipts for AI features
(function() {
  'use strict';

  var TORK_CONFIG = {
    enabled: true,
    piiDetection: true,
    complianceReceipts: true,
    logLevel: 'info'
  };

  // PII patterns - Australian-focused
  var PII_PATTERNS = {
    email: /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g,
    phone: /(?:\+61|0)[2-478](?:[ -]?\d){8}/g,
    medicare: /\d{4}[ -]?\d{5}[ -]?\d{1}/g,
    tfn: /\d{3}[ -]?\d{3}[ -]?\d{3}/g,
    creditCard: /\b(?:\d{4}[ -]?){3}\d{4}\b/g,
    postcode: /\b(?:0[289]|[1-9]\d)\d{2}\b/g
  };

  // Redact PII from text before sending to AI
  function redactPII(text) {
    if (!TORK_CONFIG.piiDetection || !text) return { text: text, redactions: [] };
    var redactions = [];
    var redacted = text;

    Object.keys(PII_PATTERNS).forEach(function(type) {
      var matches = redacted.match(PII_PATTERNS[type]);
      if (matches) {
        matches.forEach(function(match) {
          redactions.push({ type: type, original: match.substring(0, 3) + '***' });
          redacted = redacted.replace(match, '[' + type.toUpperCase() + '_REDACTED]');
        });
      }
    });

    return { text: redacted, redactions: redactions };
  }

  // Generate compliance receipt for each AI interaction
  function generateReceipt(action, input, decision) {
    if (!TORK_CONFIG.complianceReceipts) return null;
    var receipt = {
      id: 'tork-' + Date.now() + '-' + Math.random().toString(36).substr(2, 6),
      timestamp: new Date().toISOString(),
      action: action,
      decision: decision || 'ALLOW',
      piiDetected: input.redactions ? input.redactions.length > 0 : false,
      redactionCount: input.redactions ? input.redactions.length : 0,
      source: 'roar4x4.com',
      governedBy: 'tork.network'
    };

    // Log receipt (in production, this would POST to Tork's API)
    if (TORK_CONFIG.logLevel === 'info') {
      console.log('[Tork Governance] Receipt:', receipt.id, '| Action:', action, '| PII:', receipt.piiDetected ? receipt.redactionCount + ' redacted' : 'none');
    }

    return receipt;
  }

  // Governance wrapper for AI API calls
  function governAICall(action, userInput, callback) {
    // Step 1: Scan input for PII
    var scanned = redactPII(userInput);

    // Step 2: Generate pre-call receipt
    var receipt = generateReceipt(action, scanned, scanned.redactions.length > 0 ? 'REDACT_AND_ALLOW' : 'ALLOW');

    // Step 3: Return governed input
    callback({
      governedInput: scanned.text,
      originalInput: userInput,
      receipt: receipt,
      redactions: scanned.redactions
    });
  }

  // Expose Tork governance API globally
  window.TorkGovernance = {
    config: TORK_CONFIG,
    redactPII: redactPII,
    generateReceipt: generateReceipt,
    governAICall: governAICall,
    version: '1.0.0',
    provider: 'tork.network'
  };

  console.log('[Tork Governance] AI governance layer active | PII detection: ON | Compliance receipts: ON | tork.network');
})();
